import React from 'react';
import { PRODUCT_DATA, MAIN_PRODUCTS, BONUSES } from '../utils/constants';
import { CheckCircle2Icon, LockIcon, ShieldIcon, CreditCardIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export const OfferSection: React.FC = () => {
  return <section id="oferta" className="py-20 px-4 bg-gradient-to-b from-gray-50 to-white scroll-mt-20" data-id="element-140">
      <div className="container mx-auto max-w-5xl" data-id="element-141">
        <div className="bg-white rounded-3xl shadow-2xl border-2 border-green-500 overflow-hidden" data-id="element-142">
          {/* Header */}
          <div className="bg-green-500 text-white text-center py-6" data-id="element-143">
            <h2 className="text-3xl md:text-4xl font-bold" data-id="element-144">
              Accedé Ahora al Megapack
            </h2>
          </div>

          <div className="p-8 md:p-12 grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-145">
            {/* Left Column: Summary */}
            <div data-id="element-146">
              <img src={PRODUCT_DATA.mainImage} alt="Megapack" className="w-full max-w-sm mx-auto mb-8 drop-shadow-xl" data-id="element-147" />

              <div className="space-y-4" data-id="element-148">
                <h3 className="font-bold text-xl text-gray-900 border-b pb-2" data-id="element-149">
                  Lo que te llevás hoy:
                </h3>

                <ul className="space-y-3" data-id="element-150">
                  {MAIN_PRODUCTS.map((product, idx) => <li key={`main-${idx}`} className="flex items-start gap-3" data-id="element-151">
                      <CheckCircle2Icon className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-152" />
                      <span className="text-gray-700 font-medium" data-id="element-153">
                        {product.title}
                      </span>
                    </li>)}

                  <li className="pt-4 pb-2" data-id="element-154">
                    <h3 className="font-bold text-xl text-gray-900 border-b pb-2" data-id="element-155">
                      Bonus Exclusivos:
                    </h3>
                  </li>

                  {BONUSES.map((bonus, idx) => <li key={`bonus-${idx}`} className="flex items-start gap-3" data-id="element-156">
                      <CheckCircle2Icon className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-157" />
                      <div className="flex-1" data-id="element-158">
                        <span className="text-gray-700 font-medium" data-id="element-159">
                          {bonus.title}
                        </span>
                        <div className="flex items-center gap-2 mt-1" data-id="element-160">
                          <span className="text-xs bg-red-100 text-red-600 font-bold px-2 py-0.5 rounded uppercase" data-id="element-161">
                            Gratis
                          </span>
                          <span className="text-xs text-gray-400 line-through" data-id="element-162">
                            {bonus.value}
                          </span>
                        </div>
                      </div>
                    </li>)}
                </ul>
              </div>
            </div>

            {/* Right Column: Price & CTA */}
            <div className="flex flex-col justify-center" data-id="element-163">
              <div className="text-center mb-8" data-id="element-164">
                <p className="text-gray-500 text-lg mb-2" data-id="element-165">
                  Valor Total:{' '}
                  <span className="line-through" data-id="element-166">
                    {PRODUCT_DATA.totalValue}
                  </span>
                </p>
                <p className="text-red-500 text-xl font-medium mb-4" data-id="element-167">
                  Precio Regular:{' '}
                  <span className="line-through decoration-red-500" data-id="element-168">
                    {PRODUCT_DATA.originalPrice}
                  </span>
                </p>

                <div className="flex items-center justify-center gap-2 mb-2" data-id="element-169">
                  <span className="text-gray-500 text-3xl md:text-4xl font-bold" data-id="element-170">
                    $
                  </span>
                  <span className="text-6xl md:text-7xl font-extrabold text-gray-900 tracking-tight" data-id="element-171">
                    19.990
                  </span>
                </div>
                <p className="text-green-600 font-bold text-xl mb-6" data-id="element-172">
                  ¡Ahorrás un {PRODUCT_DATA.savingsPercentage}!
                </p>

                <div className="flex justify-center mb-8" data-id="element-173">
                  <CountdownTimer variant="red" data-id="element-174" />
                </div>

                <a href={PRODUCT_DATA.paymentLink} target="_blank" rel="noopener noreferrer" className="block w-full bg-green-500 hover:bg-green-600 text-white text-2xl font-bold py-6 rounded-2xl shadow-[0_0_20px_rgba(34,197,94,0.4)] hover:shadow-[0_0_30px_rgba(34,197,94,0.6)] transition-all duration-300 animate-pulse-fast mb-6" data-id="element-175">
                  COMPRAR AHORA
                </a>

                {/* Payment Badges (Stylized divs) */}
                <div className="flex justify-center gap-2 mb-8 flex-wrap" data-id="element-176">
                  <div className="px-3 py-1 bg-blue-900 text-white text-xs font-bold rounded" data-id="element-177">
                    VISA
                  </div>
                  <div className="px-3 py-1 bg-gradient-to-r from-red-500 to-orange-500 text-white text-xs font-bold rounded" data-id="element-178">
                    MASTERCARD
                  </div>
                  <div className="px-3 py-1 bg-blue-500 text-white text-xs font-bold rounded italic" data-id="element-179">
                    PayPal
                  </div>
                  <div className="px-3 py-1 bg-blue-400 text-white text-xs font-bold rounded" data-id="element-180">
                    AMEX
                  </div>
                  <div className="px-3 py-1 bg-black text-white text-xs font-bold rounded" data-id="element-181">
                    Apple Pay
                  </div>
                </div>
              </div>

              {/* Trust Box */}
              <div className="bg-green-50 rounded-2xl p-6 space-y-4 mb-6 border border-green-100" data-id="element-182">
                <div className="flex items-start gap-4" data-id="element-183">
                  <LockIcon className="w-8 h-8 text-green-600 flex-shrink-0" data-id="element-184" />
                  <div data-id="element-185">
                    <h4 className="font-bold text-green-900" data-id="element-186">
                      Transacción Segura al 100%
                    </h4>
                    <p className="text-sm text-green-800" data-id="element-187">
                      Protegido con encriptación SSL a 256 bit
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4" data-id="element-188">
                  <ShieldIcon className="w-8 h-8 text-green-600 flex-shrink-0" data-id="element-189" />
                  <div data-id="element-190">
                    <h4 className="font-bold text-green-900" data-id="element-191">
                      Garantía 45 Días
                    </h4>
                    <p className="text-sm text-green-800" data-id="element-192">
                      Satisfecho o reembolsado. Ningún riesgo.
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4" data-id="element-193">
                  <CreditCardIcon className="w-8 h-8 text-green-600 flex-shrink-0" data-id="element-194" />
                  <div data-id="element-195">
                    <h4 className="font-bold text-green-900" data-id="element-196">Pago Único</h4>
                    <p className="text-sm text-green-800" data-id="element-197">
                      Sin suscripciones. Sin costos ocultos.
                    </p>
                  </div>
                </div>
              </div>

              {/* Next Steps Box */}
              <div className="bg-gray-50 rounded-2xl p-6 border border-gray-200" data-id="element-198">
                <h4 className="font-bold text-gray-900 mb-4 text-center" data-id="element-199">
                  ¿Qué pasa después de la compra?
                </h4>
                <ol className="space-y-3 text-sm text-gray-700" data-id="element-200">
                  <li className="flex gap-2" data-id="element-201">
                    <span className="font-bold text-blue-600" data-id="element-202">1.</span>{' '}
                    Completás el pago seguro.
                  </li>
                  <li className="flex gap-2" data-id="element-203">
                    <span className="font-bold text-blue-600" data-id="element-204">2.</span> Recibís
                    un email inmediato con el acceso.
                  </li>
                  <li className="flex gap-2" data-id="element-205">
                    <span className="font-bold text-blue-600" data-id="element-206">3.</span>{' '}
                    Descargás todo el material en tu dispositivo.
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};